import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const InviteAccept = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);
  const [message, setMessage] = useState('');
  const [inviteData, setInviteData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifyInvite = async () => {
      try {
        const response = await fetch(`/api/invitations/verify/${token}`);
        const data = await response.json();
        
        if (response.ok) {
          setInviteData(data);
          setMessage('Invitation verified. Please complete registration.');
          setTimeout(() => {
            navigate(`/register?token=${token}&email=${data.email || ''}`);
          }, 2000);
        } else {
          setError(data.error || 'Invalid or expired invitation');
        }
      } catch (error) {
        setError('An error occurred while verifying your invitation');
      } finally {
        setVerifying(false);
      }
    };

    verifyInvite();
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Organization Invitation
          </h2>
        </div>
        <div className="mt-8 bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {verifying ? (
            <div className="flex flex-col items-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
              <p className="mt-4 text-sm text-gray-500">Verifying your invitation...</p>
            </div>
          ) : error ? (
            <div className="text-center text-red-600">
              <p className="text-lg">{error}</p>
              <button
                onClick={() => navigate('/login')}
                className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Back to Login
              </button>
            </div>
          ) : (
            <div className="text-center text-green-600">
              <p className="text-lg">{message}</p>
              {inviteData && (
                <div className="mt-4 text-gray-700">
                  <p>You have been invited to join {inviteData.organizationName || 'an organization'}.</p>
                  <p className="mt-2">You will be redirected to complete your registration...</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InviteAccept; 